export class Loadmore {

	init() {
		const loadmore_button = $( '.button-loadmore' )
		loadmore_button.click( function ( e ) {
			e.preventDefault()
			$( this ).toggleClass( 'loading' )
		} )
	}

}


// WEBPACK FOOTER //
// ./scripts/components/loadmore.js